module.exports = __webpack_public_path__ + "img/Slide25.190b7d2c.png";